import React, { useEffect, useState } from "react";
import { cutText, empty, kopecks2rubStr } from "../../../common/functions";
import { IContractorService } from "../logics/types";
import IconAdd2basket from "../../../common/assets/icons/addToBasket.png";
import {ServiceCounter} from "./ServiceCounter";
import { StarFill, BoxArrowUpRight } from "react-bootstrap-icons";
import { Button } from "react-bootstrap";
import "../styles/ServiceListItem.css";
import { $SiteColors } from "../../../common/config/company-atts";

interface IServiceListItem {
  countInBasket: number,
  setSeviceIDsInBasket2: React.Dispatch<React.SetStateAction<object>>,
  service: IContractorService,
  seviceIDsInBasket2: object,
  inBasket: boolean,
  forAllAndGroupName: {
    forAll: boolean,
    groupName: string
  },
}

export const ServiceListItem = ({service, inBasket, setSeviceIDsInBasket2, seviceIDsInBasket2, countInBasket, forAllAndGroupName}: IServiceListItem) => {   
  const [count, setCount] = useState(countInBasket)

  useEffect(() => {
    setCount(countInBasket)
    console.log("list_item:", countInBasket)
  }, [countInBasket])


  useEffect(() => {
    if(count == 0) {
      let tmp = Object.assign({}, seviceIDsInBasket2)
      //@ts-ignore
      delete tmp[service.id+'']
      setSeviceIDsInBasket2(tmp)
    } else if(count > 0) {
      setSeviceIDsInBasket2(prev => ({ ...prev, [service.id+'']: count }))
    }
  }, [count])
  console.log("forAll:",forAllAndGroupName)
  let nameLen = empty(service.name) ? 0 : service.name.length
  let cutLen = 29
  let maxHeight = 140
  let rateEmpty = empty(service.rating)
  if(nameLen < 32){

  } else if(nameLen < 64) {
    cutLen = 60
    maxHeight = 160
  } else {
    cutLen = 90
    maxHeight = 240
  }
  if(!rateEmpty && forAllAndGroupName.forAll) maxHeight += 20

  let servName =  cutText(service.name, cutLen, '...', '')
  console.log(service.name, service.id)
  if(service.id ==541){
    console.log(service)
    console.log(nameLen)
    console.log(cutLen)
    console.log(maxHeight)
    console.log(rateEmpty)
  }

  return (
    <div className="row col-12 sli_main_container cp" style={{ maxHeight: `${maxHeight}px` }}>
      <div className="row col-12 sli_service_name">{servName}</div>
      <div className="row col-12 sli_group_and_rate_con">
        <div className="sli_group_name" >{cutText(forAllAndGroupName.groupName, 19, '...', '')}</div>
        {empty(service.rating) ? <></> : <div className="sli_service_rate"><StarFill className="m-auto" style={{width: "20px", paddingBottom: "2px"}}/><label className="h-100 m-0 pl-1">{service.rating}</label></div>}
        {forAllAndGroupName.forAll ? <Button className="sli_go_to_site" variant="link" ><a target="_blank" href={service.viewPath == null ? "" :service.viewPath }><BoxArrowUpRight/></a></Button> : <></>}
      </div>
      <div className="row col-12 d-flex text-left p-0 m-auto pb-2" >
        {forAllAndGroupName.forAll ? <></>:
          <>
            <span className="sli_price" >{//@ts-ignore
            kopecks2rubStr(service.price) + " за усл."}</span>
            {count > 0 ? <div className="ml-auto"> <ServiceCounter val={count} setVal={setCount} /></div>:
              <Button variant="default"  onClick={() => setCount(1)} className="sli_btn_add_to_basket" style={{ background: $SiteColors.getState().backBtnSubmit }} title="Добавить услугу в корзину">
              <img src={IconAdd2basket} style={{width: "20px"}} />
            </Button>}
          </>
        }
      </div>
    </div>
  );
};
